import { render } from "./CalendlyWidget.vue?vue&type=template&id=1624c990&scoped=true"
import script from "./CalendlyWidget.vue?vue&type=script&lang=js"
export * from "./CalendlyWidget.vue?vue&type=script&lang=js"

import "./CalendlyWidget.vue?vue&type=style&index=0&id=1624c990&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1624c990"]])

export default __exports__